/** It is `true` if the user's platform is Mac */
export const isMac =
  // Suppress TypeScript error for 'userAgentData' property and deprecated warning for 'navigator.platform'
  // @ts-ignore
  /^macOS|Mac|iPod|iPhone|iPad/.test(navigator.userAgentData?.platform ?? navigator.platform);

/** Returns `true` when Meta is pressed, if it is Mac; otherwise, if Ctrl is pressed. */
export const isModKey = (event: React.MouseEvent | MouseEvent) => (isMac ? event.metaKey : event.ctrlKey);

export const numberInputStyling = {
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  MozAppearance: 'textfield',
  paddingLeft: '0px',
};
